export default "__VITE_ASSET__jCRz5wQZ__"